import { useEffect, useState } from "react";
import { useParams, Navigate } from "react-router-dom";
import api from "../lib/api";
import { aptUrl } from "../lib/site";

// Legacy /appartamento/:uuid → redirect to the new SEO slug URL (client-side 301-equivalent).
export default function ApartmentRedirect() {
  const { id } = useParams();
  const [to, setTo] = useState(undefined);
  useEffect(() => {
    api.get(`/apartments/${id}`)
      .then((r) => setTo(r.data && r.data.slug ? aptUrl(r.data) : "/"))
      .catch(() => setTo("/pagina-non-trovata"));
  }, [id]);
  if (to === undefined) return <div className="min-h-screen bg-ivory" />;
  return <Navigate to={to} replace />;
}
